/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { wcfConfig } from "../../WcfConfig";
import { AjaxConnectionError, AjaxTimeoutError, AjaxAbortedError } from "./../Ajax";
import { isString } from "../../string";
import { isPlainObject } from "../../object";
/** @internal */
export class AjaxRequest {
    constructor(pMethod, pUrl, pData, pOptions, pBefore) {
        this.onXhrAbort = () => {
            if (!this.mAborted) {
                //this happens if abort() was called directly at the XHR object
                //we need to do our internal abort handling
                this.internal_abort(true);
            }
        };
        this.onXhrError = () => {
            if (!this.mAborted) {
                this.internal_abort(false);
                this.mPromiseReject({ error: new AjaxConnectionError(this.mUrl), xhr: this.mXhr, response: null });
            }
        };
        this.onXhrTimeout = () => {
            if (!this.mAborted) {
                this.internal_abort(false);
                this.mPromiseReject({ error: new AjaxTimeoutError(this.mUrl), xhr: this.mXhr, response: null });
            }
        };
        this.onXhrLoad = () => {
            if (this.mXhr == null) {
                console.error('Invalid state, xhr = null');
                return;
            }
            // Stop sending state
            this.mSending = false;
            // Verify if the request has not been previously aborted
            if (this.mAborted) {
                return;
            }
            let tResponse;
            // Handle response
            try {
                // Process response
                if (this.mNativeResponseParsing) {
                    if ('response' in this.mXhr && this.mXhr.response === null) {
                        throw 'The request response is empty';
                    }
                    tResponse = this.mXhr.response;
                }
                else {
                    // Guess response type
                    let tResponseType = this.mOptions.responseType;
                    if (tResponseType === 'auto') {
                        const tCt = this.mXhr.getResponseHeader('Content-Type') || '';
                        if (tCt.indexOf(AjaxRequest.MIME_TYPES.json) > -1) {
                            tResponseType = 'json';
                        }
                        else if (tCt.indexOf(AjaxRequest.MIME_TYPES.xml) > -1) {
                            tResponseType = 'xml';
                        }
                        else {
                            tResponseType = 'text';
                        }
                    }
                    // Handle response type
                    switch (tResponseType) {
                        case 'json':
                            if (this.mXhr.responseText.length) {
                                try {
                                    tResponse = JSON.parse(this.mXhr.responseText);
                                }
                                catch (e) {
                                    throw new Error("Error while parsing JSON: " + e);
                                }
                            }
                            break;
                        case 'xml':
                            try {
                                tResponse = (new DOMParser()).parseFromString(this.mXhr.responseText, 'text/xml');
                            }
                            catch (e) {
                                tResponse = undefined;
                                throw new Error("Error while parsing XML: " + e);
                            }
                            if (!tResponse || !tResponse.documentElement || tResponse.getElementsByTagName('parsererror').length) {
                                throw new Error('Invalid XML');
                            }
                            break;
                        default:
                            tResponse = this.mXhr.responseText;
                    }
                }
                // Late status code verification to allow passing data when, per example, a 409 is returned
                // --- https://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
                if ('status' in this.mXhr && !/^2|1223/.test(this.mXhr.status.toString())) {
                    throw this.mXhr.status + ' (' + this.mXhr.statusText + ')';
                }
                // resolve promise
                this.mPromiseResolve({ xhr: this.mXhr, response: tResponse });
            }
            catch (pError) {
                //reject promise
                this.mPromiseReject({ error: pError, xhr: this.mXhr, response: tResponse });
            }
        };
        this.mMethod = pMethod.toUpperCase();
        this.mUrl = pUrl;
        this.mData = pData === undefined ? null : pData;
        this.mXhr = null;
        this.mAborted = false;
        this.mSending = false;
        this.mNativeResponseParsing = false;
        this.mBeforeCallback = pBefore;
        //copy default options
        this.mOptions = Object.assign({}, wcfConfig.ajaxDefaultOptions);
        this.mOptions.headers = Object.assign({}, wcfConfig.ajaxDefaultOptions.headers);
        //merge options
        const tOptions = pOptions;
        for (const tKey in tOptions) {
            const tValue = tOptions[tKey];
            if (tValue == null)
                continue;
            if (tKey === "headers") {
                //merge header dictionary
                for (const tKey2 in tValue) {
                    this.mOptions[tKey][tKey2] = tValue[tKey2];
                }
            }
            else {
                this.mOptions[tKey] = tValue;
            }
        }
        this.prepareData();
        this.prepareHeaders();
        this.prepareUrl();
    }
    execute() {
        const tPromise = new Promise((pResolve, pReject) => {
            this.mPromiseReject = pReject;
            this.mPromiseResolve = pResolve;
        });
        this.send();
        return (tPromise);
    }
    abort() {
        this.internal_abort(true);
    }
    prepareData() {
        if (this.mData instanceof ArrayBuffer) {
            this.mOptions.dataType = 'arraybuffer';
        }
        else if (this.mData instanceof Blob) {
            this.mOptions.dataType = 'blob';
        }
        else if (this.mData instanceof Document) {
            this.mOptions.dataType = 'document';
        }
        else if (this.mData instanceof FormData) {
            this.mOptions.dataType = 'formdata';
        }
        if (this.mData !== null) {
            switch (this.mOptions.dataType) {
                case 'json':
                    this.mData = JSON.stringify(this.mData);
                    break;
                case 'post':
                case 'queryString':
                    this.mData = this.getQueryString(this.mData);
            }
        }
    }
    prepareHeaders() {
        const tNewHeaders = {};
        const addHeader = (pKey, pValue) => {
            if (!(pKey in tNewHeaders))
                tNewHeaders[pKey] = pValue;
        };
        //guess if we're dealing with a cross-origin request
        const tMatch = this.mUrl.match(/\/\/(.+?)\//);
        const tIsCrossOrigin = tMatch && (tMatch[1] ? tMatch[1] != location.host : false);
        //format header
        const format = (match, p1, p2) => {
            return p1 + p2.toUpperCase();
        };
        for (const tKey in this.mOptions.headers) {
            tNewHeaders[tKey.replace(/(^|-)([^-])/g, format)] = this.mOptions.headers[tKey];
        }
        //add Content-Type header
        if (this.mMethod !== 'GET' && this.mOptions.dataType in AjaxRequest.MIME_TYPES) {
            if (AjaxRequest.MIME_TYPES[this.mOptions.dataType]) {
                addHeader('Content-Type', AjaxRequest.MIME_TYPES[this.mOptions.dataType]);
            }
        }
        //add Accept header
        addHeader('Accept', (this.mOptions.responseType in AjaxRequest.ACCEPT) ? AjaxRequest.ACCEPT[this.mOptions.responseType] : '*/*');
        //add X-Requested-With header (that header breaks in legacy browsers with CORS)
        if (!tIsCrossOrigin) {
            addHeader('X-Requested-With', 'XMLHttpRequest');
        }
        //add Cache-Control header
        if (!this.mOptions.cache) {
            addHeader('Cache-Control', 'no-cache');
        }
        this.mOptions.headers = tNewHeaders;
    }
    prepareUrl() {
        if ((this.mMethod == 'GET' || this.mOptions.dataType == 'queryString') &&
            this.mData != null && isString(this.mData)) {
            this.mUrl += (/\?/.test(this.mUrl) ? '&' : '?') + this.mData;
        }
    }
    send() {
        // Prevent further send() calls and verify if the request has not been previously aborted
        if (this.mSending || this.mAborted) {
            return;
        }
        // The sending is running
        this.mSending = true;
        // Get XHR object
        this.mXhr = new XMLHttpRequest();
        // Open connection
        this.mXhr.open(this.mMethod, this.mUrl, true, this.mOptions.user, this.mOptions.password);
        this.mXhr.withCredentials = this.mOptions.withCredentials;
        // Set headers
        for (const tKey in this.mOptions.headers) {
            if (this.mOptions.headers[tKey]) {
                this.mXhr.setRequestHeader(tKey, this.mOptions.headers[tKey]);
            }
        }
        // Verify if the response type is supported by the current browser
        if (this.mOptions.responseType != 'auto' && this.mOptions.responseType != 'xml') {
            try {
                this.mXhr.responseType = this.mOptions.responseType;
                this.mNativeResponseParsing = (this.mXhr.responseType == this.mOptions.responseType);
            }
            catch (e) { } //eslint-disable-line no-empty
        }
        // Plug response handler
        this.mXhr.onload = this.onXhrLoad;
        this.mXhr.onerror = this.onXhrError;
        this.mXhr.onabort = this.onXhrAbort;
        // Plug timeout
        this.mXhr.timeout = this.mOptions.timeout;
        this.mXhr.ontimeout = this.onXhrTimeout;
        // Override mime type to ensure the response is well parsed
        if (this.mOptions.responseType != 'auto' && 'overrideMimeType' in this.mXhr) {
            const tMimeType = AjaxRequest.MIME_TYPES[this.mOptions.responseType];
            if (tMimeType != null) {
                this.mXhr.overrideMimeType(tMimeType);
            }
        }
        // Run 'before' callback
        if (this.mBeforeCallback != null) {
            this.mBeforeCallback(this.mXhr);
        }
        // Send request
        this.mXhr.send(this.mMethod != 'GET' ? this.mData : null);
    }
    internal_abort(pExternalAbort) {
        if (!this.mAborted) {
            this.mSending = false;
            this.mAborted = true;
            if (this.mXhr != null && this.mXhr.readyState != 4) { // https://stackoverflow.com/questions/7287706/ie-9-javascript-error-c00c023f
                this.mXhr.abort();
            }
            //reject the promise with an abort error
            if (pExternalAbort && this.mXhr != null) {
                this.mPromiseReject({
                    error: new AjaxAbortedError(this.mUrl),
                    xhr: this.mXhr,
                    response: null
                });
            }
        }
    }
    getQueryString(pData) {
        if (isString(pData)) {
            return (pData);
        }
        else {
            if (isPlainObject(pData)) {
                const tParams = new URLSearchParams();
                for (const tKey in pData) {
                    tParams.append(tKey, pData[tKey]);
                }
                return (tParams.toString());
            }
        }
        return ("");
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
AjaxRequest.MIME_TYPES = {
    text: '*/*',
    xml: 'text/xml',
    json: 'application/json',
    post: 'application/x-www-form-urlencoded',
    document: 'text/html'
};
AjaxRequest.ACCEPT = {
    text: '*/*',
    xml: 'application/xml; q=1.0, text/xml; q=0.8, */*; q=0.1',
    json: 'application/json; q=1.0, text/*; q=0.8, */*; q=0.1'
};
